/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgBell = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M13.417 9.917c0 .35-.234.583-.584.583H1.167c-.35 0-.584-.233-.584-.583s.234-.583.584-.583a1.17 1.17 0 0 0 1.166-1.167V5.25A4.68 4.68 0 0 1 7 .583a4.68 4.68 0 0 1 4.667 4.667v2.917a1.17 1.17 0 0 0 1.166 1.167c.35 0 .584.233.584.583m-4.9 2.625c-.35.583-.934.875-1.517.875-.292 0-.583-.059-.875-.233a1.7 1.7 0 0 1-.642-.642c-.175-.292-.058-.642.234-.817.291-.175.641-.058.816.234q.027.027.055.065c.044.058.097.127.179.168.291.175.641.058.816-.233s.525-.35.817-.234c.292.117.292.525.117.817M10.5 8.167c0 .408.117.816.292 1.167H3.208c.175-.35.292-.759.292-1.167V5.25A3.51 3.51 0 0 1 7 1.75a3.51 3.51 0 0 1 3.5 3.5z"
      clipRule="evenodd"
    />
    <mask
      id="bell_svg__a"
      width={14}
      height={14}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13.417 9.917c0 .35-.234.583-.584.583H1.167c-.35 0-.584-.233-.584-.583s.234-.583.584-.583a1.17 1.17 0 0 0 1.166-1.167V5.25A4.68 4.68 0 0 1 7 .583a4.68 4.68 0 0 1 4.667 4.667v2.917a1.17 1.17 0 0 0 1.166 1.167c.35 0 .584.233.584.583m-4.9 2.625c-.35.583-.934.875-1.517.875-.292 0-.583-.059-.875-.233a1.7 1.7 0 0 1-.642-.642c-.175-.292-.058-.642.234-.817.291-.175.641-.058.816.234q.027.027.055.065c.044.058.097.127.179.168.291.175.641.058.816-.233s.525-.35.817-.234c.292.117.292.525.117.817M10.5 8.167c0 .408.117.816.292 1.167H3.208c.175-.35.292-.759.292-1.167V5.25A3.51 3.51 0 0 1 7 1.75a3.51 3.51 0 0 1 3.5 3.5z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#bell_svg__a)">
      <path fill="#fff" d="M0 0h14v14H0z" />
    </g>
  </svg>
)
export default SvgBell
